import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { VoucherType } from '@vi-iot/client';

import { VouchersActions } from './vouchers.actions';
import { VouchersSelectors } from './vouchers.selectors';

@Injectable({
  providedIn: 'root',
})
export class VouchersStore {
  isGeneratingVoucher$ = this.store.select(VouchersSelectors.getIsGeneratingVoucher());
  getAttemptedToGenerateVoucher$ = this.store.select(
    VouchersSelectors.getAttemptedToGenerateVoucher()
  );
  voucherGeneratedSuccesfully$ = this.store.select(
    VouchersSelectors.getVoucherGeneratedSuccessfully()
  );
  voucher$ = this.store.select(VouchersSelectors.getVoucher());

  isValidatingVoucher$ = this.store.select(VouchersSelectors.isValidatingVoucher());
  getAttemptedToValidateVoucher$ = this.store.select(
    VouchersSelectors.getAttemptedToValidateVoucher()
  );
  voucherValidatedSuccesfully$ = this.store.select(
    VouchersSelectors.getVoucherValidatedSuccessfully()
  );
  isVoucherAvailable$ = this.store.select(VouchersSelectors.getIsVoucherAvailable());

  constructor(private store: Store) {}

  generateSrcLiteVoucher(voucherType: VoucherType, companyNumber?: string): void {
    this.store.dispatch(VouchersActions.GenerateVoucher({ voucherType, companyNumber }));
  }

  validateSrcLiteVoucher(voucher: string): void {
    this.store.dispatch(VouchersActions.ValidateVoucher({ voucher }));
  }

  clearState(): void {
    this.store.dispatch(VouchersActions.ClearState());
  }
}
